import React, { useMemo } from 'react';
import { SectionConfig, ObjectType } from '../../types/metadata';
import { Layers, ChevronRight } from 'lucide-react';
interface SectionSidebarProps {
  sections: SectionConfig[];
  selectedSectionKey: string | null;
  onSelectSection: (key: string | null) => void;
  getFieldCount: (key: string) => number;
}
export function SectionSidebar({
  sections,
  selectedSectionKey,
  onSelectSection,
  getFieldCount
}: SectionSidebarProps) {
  const groupedSections = useMemo(() => {
    const groups: Record<string, SectionConfig[]> = {
      [ObjectType.Lead]: [],
      [ObjectType.Account]: [],
      [ObjectType.Opportunity]: []
    };
    sections.forEach(s => {
      if (groups[s.objectType]) {
        groups[s.objectType].push(s);
      }
    });
    Object.keys(groups).forEach(key => {
      groups[key].sort((a, b) => a.order - b.order);
    });
    return groups;
  }, [sections]);
  const groupColors = {
    [ObjectType.Lead]: 'text-blue-700 bg-blue-50 border-l-blue-400',
    [ObjectType.Account]: 'text-purple-700 bg-purple-50 border-l-purple-400',
    [ObjectType.Opportunity]: 'text-emerald-700 bg-emerald-50 border-l-emerald-400'
  };
  return <div className="w-72 flex-shrink-0 bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex flex-col" data-id="element-155">
      <div className="p-4 border-b border-gray-200 flex-shrink-0" data-id="element-156">
        <h3 className="font-semibold text-sm text-gray-900 flex items-center gap-2" data-id="element-157">
          <Layers className="w-4 h-4 text-blue-600" data-id="element-158" />
          Form Sections
        </h3>
      </div>

      <div className="overflow-y-auto flex-1 p-2 space-y-3" data-id="element-159">
        <button onClick={() => onSelectSection(null)} className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${selectedSectionKey === null ? 'bg-blue-600 text-white shadow-sm' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-160">
          All Fields
        </button>

        {Object.entries(groupedSections).map(([objectType, objectSections]) => {
        if (objectSections.length === 0) return null;
        return <div key={objectType} className="space-y-0.5" data-id="element-161">
              <div className={`px-3 py-1.5 text-xs font-bold uppercase tracking-wider rounded-md border-l-2 ${groupColors[objectType as ObjectType]}`} data-id="element-162">
                {objectType}
              </div>

              <ul className="space-y-0.5 mt-1" data-id="element-163">
                {objectSections.map(section => {
              const isSelected = selectedSectionKey === section.sectionKey;
              const fieldCount = getFieldCount(section.sectionKey);
              return <li key={section.id} data-id="element-164">
                      <button onClick={() => onSelectSection(section.sectionKey)} className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors group ${isSelected ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-165">
                        <div className="flex items-center gap-2 truncate" data-id="element-166">
                          <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${section.active ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-167" />
                          <span className="truncate" title={section.sectionLabel} data-id="element-168">
                            {section.sectionLabel}
                          </span>
                        </div>
                        <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-169">
                          <span className={`text-xs tabular-nums px-1.5 py-0.5 rounded-full ${isSelected ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-500'}`} data-id="element-170">
                            {fieldCount}
                          </span>
                          <ChevronRight className={`w-3.5 h-3.5 transition-colors ${isSelected ? 'text-blue-400' : 'text-transparent group-hover:text-gray-300'}`} data-id="element-171" />
                        </div>
                      </button>
                    </li>;
            })}
              </ul>
            </div>;
      })}
      </div>
    </div>;
}